require('dotenv').config()

export const APP_ENVIRONMENTS = {
  ETHEREUM_PROVIDER: String(process.env.ETHEREUM_PROVIDER || 'https://mainnet.infura.io/v3/d6e76dfa7d814896b867f07a79ec0e7a'),
  RINKEBY_PROVIDER: String(process.env.RINKEBY_PROVIDER || 'https://rinkeby.infura.io/v3/d6e76dfa7d814896b867f07a79ec0e7a')
}